<div class="template-list-action-bar">
    <r1-compass-lib-breadcrumb-list [breadcrumbList]="breadcrumbs()" (noBreadcrumbsBackupEvent)="goToRoot()" />
    <button mat-raised-button [matMenuTriggerFor]="menu" color="primary" type="button">+ New</button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onCreateAsset()" type="button">Template Criteria</button>
        <button mat-menu-item (click)="onCreateFolder()" type="button">Folder</button>
    </mat-menu>
</div>

<r1-compass-lib-file-table
    [columns]="columns"
    [fileTableData]="sortedFileTableEntries()"
    [searchedFilesAndFolders]="searchContent()"
    (folderChange)="onChangeFolder($event)"
    (editAsset)="onEditAsset($event)"
    (clickOption)="onOptionClicked($event)"
    (searchFilesAndFolders)="onTypeaheadSearch($event)"
    (openDependencies)="onOpenDependencies($event)" />
